<script>
    export default {
        props: {
            isSuccess: {
                type: Boolean,
                default: null,
            },
            title : {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            button: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
        },
    }
</script>

<template class="toast">
    <div class="toast-background-dish">
        <div class="toast-container-dish" :class="isSuccess ? 'toast-success' : 'toast-error'">
            <span class="close" v-on:click="$emit('close', true)">&times;</span>
            <img v-show="!isSuccess" src="@/assets/images/toast-error.svg" alt="error icon">
            <img v-show="isSuccess" src="@/assets/images/toast-success.svg" alt="success icon">
            <h1>{{ title }}</h1>
            <p>{{ description }}</p>
            <button v-on:click="$emit('close', true)">{{ button }}</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/components/toast';
</style>